export const MSL_HEX_CODE = 0;
export const MSL_INTEGRITY_CHECK = 1;
export const MSL_CIPHERING = 2;
export const MSL_COUNTER = 3;
export const MSL_VALUE_MATRIX = [
  ["00", "1", "1", "1"],
  ["01", "2", "1", "1"],
  ["02", "3", "1", "1"],
  ["03", "4", "1", "1"],
  ["04", "1", "2", "1"],
  ["05", "2", "2", "1"],
  ["06", "3", "2", "1"],
  ["07", "4", "2", "1"],
  ["08", "1", "1", "2"],
  ["09", "2", "1", "2"],
  ["09", "2", "1", "4"],
  ["0A", "3", "1", "2"],
  ["0B", "4", "1", "2"],
  ["0C", "1", "2", "2"],
  ["0D", "2", "2", "2"],
  ["0E", "3", "2", "2"],
  ["0F", "4", "2", "2"],
  ["10", "1", "1", "3"],
  ["11", "2", "1", "3"],
  ["12", "3", "1", "3"],
  ["13", "4", "1", "3"],
  ["14", "1", "2", "3"],
  ["15", "2", "2", "3"],
  ["16", "3", "2", "3"],
  ["17", "4", "2", "3"],
  ["18", "1", "1", "4"],
  ["19", "2", "1", "4"],
  ["1A", "3", "1", "4"],
  ["1B", "4", "1", "4"],
  ["1C", "1", "2", "4"],
  ["1D", "2", "2", "4"],
  ["1E", "3", "2", "4"],
  ["1F", "4", "2", "4"],
];
